// Karsilama paneli ekrandayken otomatik kaydirma tamamen kapali.
//
// Sohbet henuz acilmadigi icin takip edilecek yeni mesaj yok: ekrandaki tek
// icerik ziyaretcinin doldurdugu form. Formun her yukseklik degisiminde
// (katlanmis kart acilirken, alan eklenirken, hata satiri cikarken) mesaj
// kabini dibe cekmek odaktaki alani ekranin disina itiyordu.
//
// Kural tek yerde: kaba yazan her kod once buraya soruyor. Boylece yeni bir
// tetikleyici eklendiginde ayni hata geri gelmiyor.
export function autoScrollDisabled() {
    if (typeof document === "undefined") return false;
    return !!document.getElementById("precall-panel");
}



// WEBPACK FOOTER //
// ./src/utils/autoScrollGuard.js